import React, { useEffect, useRef, useState } from 'react';
import { get, post, put, patch } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon, DownloadIcon, UploadIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import { MdDelete } from 'react-icons/md';
import { getStoredData, get_auth_key } from '../util';
import { GrDocumentPdf, GrDocumentExcel } from 'react-icons/gr';
import useDebounce from './useDebounce';
import Breadcrumb from '../components/Breadcrumb';
import Company from '../components/company';

const Disposal = () => {
  const formFields = {
    date_of_disposals: new Date().toJSON().slice(0, 10),
    buyer_name: '',
    buyer_gst: '',
    buyer_address: '',
    buyer_contact: '',
    buyer_email: '',
    assetsInfo: [],
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [disposalForm, setDisposalForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  // const [idToDeleted, setIdToDeleted] = useState("");
  // const [deleteModel, setDeleteModel] = useState(false);
  const [disposalList, setDisposalList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [assetCategoryList, setAssetCategoryList] = useState([]);
  const [assetList, setAssetList] = useState({});
  const [view, setView] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [inputFields, setInputFields] = useState([]);
  const [locationType, setLocationType] = useState('');
  const [uploadModel, setUploadModel] = useState(false);
  const [idToUpdated, setIdToUpdated] = useState('');

  const clickAssetBtn = useRef(null);
  const clickToDownload = useRef(null);
  const storedData = JSON.parse(getStoredData(get_auth_key()));

  const admins = ['admin', 'super-admin', 'fixed-asset-admin'].includes(storedData.role);

  const [state, setState] = useState({
    query: '',
    locationId: !admins ? storedData?.locationId[0] || '' : '',
    assetCategoryQuery: '',
    dateFrom: '',
    dateTo: '',
    companyId: !admins ? storedData?.companyId || '' : '',
  });

  const handleShow = () => {
    setShowConfirmModel(true);
    setDisposalForm(formFields);
    setTimeout(() => {
      clickAssetBtn.current?.click();
    }, 100);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
    setInputFields([]);
    setView(false);
    setSubTotal(0);
    setDisposalForm(formFields);
  };

  const handleViewAndEdit = async (e, id, view, conditionType) => {
    e.preventDefault();
    try {
      {
        conditionType !== 'download' ? setShowConfirmModel(true) : setShowConfirmModel(false);
      }
      get(`/disposals/${id}/?conditionType=${conditionType}`).then((response) => {
        if (conditionType !== 'download') {
          let _disposalForm = response.data;
          setDisposalForm(_disposalForm);
          let _inputFields = _disposalForm.assetsInfo;
          setView(view);
          setSubTotal(_disposalForm.total);
          let _assetList = {};
          (async () => {
            for (let x = 0; x < _inputFields.length; x++) {
              const da = await get(`/assets/?locationId=${_inputFields[x].locationId}&assetCategoryId=${_inputFields[x].assetCategoryId}`);
              _assetList = { ..._assetList, [x]: da.data.rows };

              let locationData = loadLocationData(_inputFields[x].locationId);
              _inputFields[x]['companyId'] = locationData?.companyId;
              _inputFields[x]['locationType'] = locationData?.type;

              // Find and set the vehicle number from the fetched assets
              const matchingAsset = da.data.rows.find(asset => asset.id === parseInt(_inputFields[x].asset_id));
              if (matchingAsset) {
                _inputFields[x]['vehicleNumber'] = matchingAsset.vehicleNumber;
              }
            }
            setAssetList(_assetList);
          })();
          setInputFields(_inputFields);
          setShowConfirmModel(true);
        } else {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const uploadInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setUploadModel(true);
  };

  let formData = new FormData();
  const handleFileChange = (e) => {
    e.preventDefault();
    formData.append('invoice', e.target.files[0]);
  };

  const handleUpload = async (e, id) => {
    e.preventDefault();
    try {
      patch(formData, '/disposals/' + id, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setUploadModel(false);
          setIdToUpdated('');
          getDisposals();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message);
        });
    } catch (err) {
      toast.error(err?.message || 'Something Went Wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let { name, value } = event.target;

    setDisposalForm({ ...disposalForm, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in disposalForm) {
      try {
        await put(disposalForm, '/disposals/' + disposalForm.id);
        toast.success('Disposal updated successfully');
        setShowConfirmModel(false);
        setInputFields([]);
        setDisposalForm(formFields);
        setView(false);
        setSubTotal(0);
        getDisposals();
      } catch (err) {
        toast.error(err.message, { autoClose: 3000 });
      }
    } else {
      try {
        post(disposalForm, '/disposals/')
          .then((res) => {
            toast.success(res.data.message);
            setShowConfirmModel(false);
            setInputFields([]);
            setDisposalForm(formFields);
            setView(false);
            setSubTotal(0);
            getDisposals();
          })
          .catch((err) => {
            toast.error(err?.response?.data?.data?.message || err.message);
          });
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getDisposals() {
    try {
      get(
        `/disposals/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${state.query}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&locationId=${state.locationId}&assetCategoryId=${state.assetCategoryQuery}&companyId=${state.companyId}`
      ).then((response) => {
        setDisposalList(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getDisposalReport() {
    try {
      get(
        `/disposals/?conditionType=download&query=${state.query}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&locationId=${state.locationId}&assetCategoryId=${state.assetCategoryQuery}&companyId=${state.companyId}`
      ).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getLocations() {
    try {
      get(`/branches/`).then((response) => {
        setLocationList(response.data.rows);
        if (!admins) {
          const data = response?.data?.rows?.find((item) => {
            return item.id === storedData?.locationId[0];
          });
          setLocationType(data?.type);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getAssetCategories() {
    try {
      get(`/asset-categories`).then((response) => {
        setAssetCategoryList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getDisposals();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getDisposals();
  }, [currentPage]);

  useEffect(() => {
    getLocations();
    getAssetCategories();
  }, []);

  const handleAddInput = () => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.push({
      assetCategoryId: '',
      asset_name: '',
      asset_number: '',
      asset_type: '',
      gst: '',
      cost_per_unit: '',
      locationId: '',
      locationType: '',
      companyId: '',
      quantity: '',
      unit: '',
      vehicleNumber: '',
    });
    setInputFields(newAssetInfo);
    setDisposalForm({ ...disposalForm, assetsInfo: newAssetInfo });
  };

  const handleRemoveInput = (index) => {
    const newAssetInfo = [...inputFields];
    setSubTotal(parseInt(subTotal) - parseInt(newAssetInfo[index]['total'] || 0));
    newAssetInfo.splice(index, 1);
    setInputFields(newAssetInfo);
    setDisposalForm({ ...disposalForm, assetsInfo: newAssetInfo });
  };

  const loadAssetDropdown = async (locationId, assetCatId, index) => {
    if (locationId !== undefined && assetCatId !== undefined) {
      get(`/assets/?locationId=${locationId}&assetCategoryId=${assetCatId}`).then((res) => {
        setAssetList({ ...assetList, [index]: res?.data?.rows });
      });
    }
  };

  const loadAssetData = (assetId, index) => {
    if (assetId !== '') {
      return assetList[index].find((item) => {
        return item?.id === parseInt(assetId);
      });
    }
  };

  const calculateTotal = (Qty, cost_per_unit, gst) => {
    return (Qty || 0) * (cost_per_unit || 0) + ((Qty || 0) * (cost_per_unit || 0) * gst) / 100;
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index][fieldName] = event.target.value;
    if (fieldName === 'assetCategoryId' || fieldName === 'locationId') {
      let locationId = newAssetInfo[index]?.locationId;
      let assetCatId = newAssetInfo[index]?.assetCategoryId;
      loadAssetDropdown(locationId, assetCatId, index);
      newAssetInfo[index]['quantity'] = '';
      newAssetInfo[index]['inStockQty'] = '';
      newAssetInfo[index]['unit'] = '';
      newAssetInfo[index]['asset_id'] = '';
      newAssetInfo[index]['asset_type'] = '';
      newAssetInfo[index]['vehicleNumber'] = '';

      let locationData = loadLocationData(locationId);
      newAssetInfo[index]['locationType'] = locationData?.type;
      newAssetInfo[index]['companyId'] = locationData?.companyId;
    } else if (fieldName === 'asset_id') {
      if (event.target.value === '') {
        newAssetInfo[index]['asset_type'] = '';
        newAssetInfo[index]['asset_name'] = '';
        newAssetInfo[index]['asset_number'] = '';
        newAssetInfo[index]['inStockQty'] = '';
        newAssetInfo[index]['unit'] = '';
        newAssetInfo[index]['quantity'] = '';
      } else {
        let data = loadAssetData(event.target.value, index);
        if (data !== undefined) {
          newAssetInfo[index]['asset_type'] = data.asset_type;
          newAssetInfo[index]['asset_name'] = data.asset_name;
          newAssetInfo[index]['asset_number'] = data.asset_number;
          newAssetInfo[index]['inStockQty'] = data.quantity;
          newAssetInfo[index]['unit'] = data.unit;
          newAssetInfo[index]['vehicleNumber'] = data.vehicleNumber;
          newAssetInfo[index]['quantity'] = '';
        }
      }
    } else if (fieldName === 'quantity' || fieldName === 'cost_per_unit' || fieldName === 'gst') {
      let quantity = newAssetInfo[index]['quantity'];
      let cost_per_unit = newAssetInfo[index]['cost_per_unit'];
      let gst = newAssetInfo[index]['gst'];
      if (fieldName === 'quantity') {
        quantity = event.target.value;
      }
      if (fieldName === 'cost_per_unit') {
        cost_per_unit = event.target.value;
      }
      if (fieldName === 'gst') {
        gst = event.target.value;
      }
      newAssetInfo[index]['total'] = calculateTotal(quantity, cost_per_unit, gst).toFixed(2);
      let amount = 0;
      for (let i = 0; i < newAssetInfo.length; i++) {
        amount += parseFloat(newAssetInfo[i]?.total || 0);
      }
      setSubTotal(amount.toFixed(2));
    }
    setInputFields(newAssetInfo);
    setDisposalForm({ ...disposalForm, assetsInfo: newAssetInfo });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'Disposals' },
        ]}
      />
      <div className="row justify-content-between align-items-center mt-2">
        <div className="col-12 text-end mb-2">
          <button type="button" className="btn app-btn-default dark-color btn-sm" onClick={handleShow}>
            Add Disposal
          </button>
          <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
        </div>
      </div>
      <div className="card custom_card">
        <div className="d-flex justify-content-between align-items-center w-100 card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-2">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Disposals | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-12 col-lg-2" style={{ marginRight: '12px' }}>
            <Company
              disabled={!admins}
              company={state.companyId}
              name="compnay"
              label="Company"
              onChange={(e) => {
                setState({ ...state, companyId: e.target.value });
              }}
            />
          </div>
          <div className="col-12 col-lg-8 text-end">
            <div className="row align-items-center">
              <div className="col-4">
                <Form.Select
                  disabled={!admins}
                  value={locationType}
                  onChange={(e) => {
                    setLocationType(e.target.value);
                    setState({ ...state, locationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>

                <FloatingLabel controlId="floatingInput" label="Disposal Start Date">
                  <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div className="col-3">
                <Form.Select
                  value={state.locationId}
                  onChange={(e) => setState({ ...state, locationId: e.target.value })}
                  className="input mb-2"
                >
                  <option value="">Select Location</option>
                  {locationList
                    .filter((item) => {
                      if (!admins) {
                        return (
                          storedData?.locationId.includes(item?.id) &&
                          item?.type === locationType &&
                          item?.companyId === parseInt(state?.companyId)
                        );
                      } else {
                        return item?.type === locationType && item?.companyId === parseInt(state?.companyId);
                      }
                    })
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>
                <FloatingLabel controlId="floatingInput" label="Disposal End Date">
                  <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div className="col-4">
                <Form.Select
                  onChange={(e) => setState({ ...state, assetCategoryQuery: e.target.value })}
                  className="input mb-2"
                  value={state.assetCategoryQuery}
                >
                  <option value="">Select Asset Category</option>
                  {assetCategoryList.map((item) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <div className="form-floating">
                  <Form.Control
                    value={state.query}
                    onChange={(e) => setState({ ...state, query: e.target.value })}
                    type="search"
                    placeholder="Search by buyer name"
                  />
                  <label htmlFor="floatingInput">Search by buyer name</label>
                </div>
              </div>
              <div className="col-1">
                <GrDocumentExcel
                  title="Download disposals report"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={getDisposalReport}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>S.N</th>
                    <th>Date of Disposal</th>
                    <th>Buyer Name</th>
                    <th>Buyer GST</th>
                    <th>Asset Category</th>
                    <th>Asset Name</th>
                    <th>Asset Number</th>
                    <th>Quantity</th>
                    <th>UoM</th>
                    <th>Location</th>
                    <th>Sub Total</th>
                    <th>Total</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {disposalList.map((item, index) => {
                    return (
                      <React.Fragment key={item?.id}>
                        <tr>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length}>
                            {(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length}>
                            {new Date(item?.date_of_disposals).toLocaleDateString('en-GB')}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length}>
                            {item?.buyer_name}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length}>
                            {item?.buyer_gst}
                          </td>
                          <td>{item?.AssetDisposalDetails[0].AssetCategory?.name}</td>
                          <td>{item?.AssetDisposalDetails[0].asset_name}</td>
                          <td>{item?.AssetDisposalDetails[0].asset_number}</td>
                          <td>{item?.AssetDisposalDetails[0].quantity}</td>
                          <td style={{ textTransform: 'capitalize' }}>{item?.AssetDisposalDetails[0].unit}</td>
                          <td>{item?.AssetDisposalDetails[0].Branch?.name}</td>
                          <td>{item?.AssetDisposalDetails[0].total}</td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length}>
                            {item?.total}
                          </td>
                          <td style={{ verticalAlign: 'middle' }} rowSpan={item?.AssetDisposalDetails.length} className="actions">
                            {/*<span onClick={(e) => handleViewAndEdit(e, item?.id, false)} className="pe-2" ><EditIcon /></span>*/}
                            {item?.invoice === null ? (
                              <a onClick={(e) => uploadInvoice(e, item?.id)}>
                                <UploadIcon style={{ color: 'green' }} />
                              </a>
                            ) : (
                              <a
                                href={
                                  item?.syncedOnBucket
                                    ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.invoice}`
                                    : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item?.invoice}`
                                }
                              >
                                <DownloadIcon style={{ color: 'purple' }} />
                              </a>
                            )}
                            <Link onClick={(e) => handleViewAndEdit(e, item?.id, true, 'viewmode')}>
                              <ViewIcon style={{ color: 'purple' }} />
                            </Link>
                            <a onClick={(e) => handleViewAndEdit(e, item?.id, false, 'download')}>
                              <GrDocumentPdf className="react-icons red" title="download pdf" />
                            </a>
                            {/* <Link onClick={(e) => handleConfirmDeleteModel(e, item?.id)} className="delete" to="/"><DeleteIcon /></Link> */}
                          </td>
                        </tr>
                        {item?.AssetDisposalDetails?.length > 1 &&
                          item?.AssetDisposalDetails.slice(1).map((asset, index) => {
                            return (
                              <tr key={index}>
                                <td className="px-2">{asset.AssetCategory?.name}</td>
                                <td className="px-2">{asset?.asset_name}</td>
                                <td className="px-2">{asset.asset_number}</td>
                                <td className="px-2">{asset?.quantity}</td>
                                <td style={{ textTransform: 'capitalize' }}>{asset?.unit}</td>
                                <td>{asset.Branch?.name}</td>
                                <td>{asset.total}</td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Add/Update Disposal */}
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>
            {view === true && 'id' in disposalForm ? 'Disposal Details' : 'id' in disposalForm ? 'Edit Disposal' : 'Add Disposal'}
          </Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <h6>Basic Info</h6>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Date of Disposal" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="date_of_disposals"
                    value={disposalForm.date_of_disposals}
                    onChange={handleChange}
                    type="date"
                    placeholder="Date of Disposal"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Name" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="buyer_name"
                    value={disposalForm.buyer_name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Buyer Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer GST" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="buyer_gst"
                    value={disposalForm.buyer_gst}
                    onChange={handleChange}
                    type="text"
                    placeholder="Buyer GST"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Address" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="buyer_address"
                    value={disposalForm.buyer_address}
                    onChange={handleChange}
                    type="text"
                    placeholder="Buyer Address"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Contact" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="buyer_contact"
                    value={disposalForm.buyer_contact}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value) && value >= 0) {
                        handleChange(e);
                      }
                    }}
                    type="text"
                    placeholder="Buyer Contact"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Email" className="mb-3">
                  <Form.Control
                    disabled={view === true}
                    className="input"
                    name="buyer_email"
                    value={disposalForm.buyer_email}
                    onChange={handleChange}
                    type="text"
                    placeholder="Buyer Email"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-2 align-items-center">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h6 className="mb-0">Asset Info</h6>
              </div>
            </Row>
            {inputFields.map((inputField, index) => (
              <>
                <div key={index} className="asset-info">
                  <Row>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                        <Form.Select
                          disabled={view === true}
                          className="input"
                          value={inputField.locationId}
                          name="locationId"
                          onChange={(e) => handleInputChange(index, e, 'locationId')}
                          placeholder="Location"
                          required
                        >
                          <option value="">Select Location</option>
                          {locationList
                            .filter((item) => {
                              if (!admins) {
                                return storedData?.locationId.includes(item?.id);
                              } else {
                                return item;
                              }
                            })
                            .map((item) => {
                              return (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              );
                            })}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col>
                      <FloatingLabel controlId="floatingInput" label="Location Type" className="mb-3">
                        <Form.Select
                          className="input"
                          disabled
                          value={inputField.locationType}
                          name="locationType"
                          onChange={(e) => handleInputChange(index, e, 'locationType')}
                          placeholder="Location Type"
                          required
                        >
                          <option value="">Location Type</option>
                          <option value="office">Office</option>
                          <option value="factory">Factory</option>
                          <option value="outlet">Outlet</option>
                          <option value="staff-room">Staff Room</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                        <Company
                          disabled
                          required
                          name="companyId"
                          label="Company"
                          company={inputField.companyId}
                          onChange={(e) => handleInputChange(index, e, 'companyId')}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Asset Category" className="mb-3">
                        <Form.Select
                          disabled={view === true}
                          className="input"
                          value={inputField.assetCategoryId}
                          name="assetCategoryId"
                          onChange={(e) => handleInputChange(index, e, 'assetCategoryId')}
                          required
                        >
                          <option value="">Select Category</option>
                          {assetCategoryList.map((item) => {
                            return (
                              <option key={item?.id} value={item?.id}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4} className="mb-3">
                      <FloatingLabel controlId="floatingInput" label="Asset Name" >
                        <Form.Select
                          disabled={view === true || inputField.assetCategoryId === ''}
                          className="input"
                          value={inputField.asset_id}
                          name="asset_name"
                          onChange={(e) => handleInputChange(index, e, 'asset_id')}
                          placeholder="Asset Name"
                          required
                        >
                          <option value="">Select Asset Name</option>
                          {assetList[index]?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.asset_name} ({item?.asset_number}) {item?.vehicleNumber ? `[${item?.vehicleNumber}]` : ''}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                      {inputField.vehicleNumber && (
                        <div style={{ fontSize: '0.9em', color: 'red' }}>
                          Vehicle Number: {inputField.vehicleNumber}
                        </div>
                      )}
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Asset Type" className="mb-3">
                        <Form.Select
                          disabled
                          className="input"
                          value={inputField.asset_type}
                          name="asset_type"
                          onChange={(e) => handleInputChange(index, e, 'asset_type')}
                          placeholder="Asset Type"
                        >
                          <option value="">Select Type</option>
                          <option value="tan">TAN</option>
                          <option value="int">INT</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Quantity">
                        <Form.Control
                          disabled={view === true || inputField?.inStockQty <= 0}
                          className="input"
                          name="quantity"
                          value={inputField.quantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value >= 0) {
                              handleInputChange(index, e, 'quantity');
                            }
                          }}
                          type="text"
                          placeholder="Quantity"
                          required
                        />
                      </FloatingLabel>
                      <span
                        className={inputField?.inStockQty >= 0 && inputField?.inStockQty !== '' ? 'text-danger' : 'd-none'}
                        style={{ fontSize: '13px', position: 'absolute' }}
                      >
                        Avl Qty {inputField?.inStockQty}
                      </span>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Unit" className="mb-3">
                        <Form.Select
                          disabled
                          className="input"
                          value={inputField.unit}
                          name="unit"
                          onChange={(e) => handleInputChange(index, e, 'unit')}
                        >
                          <option value="">Select Unit</option>
                          <option value="number">Number</option>
                          <option value="set">Set</option>
                          <option value="pc">Pc</option>
                          <option value="kg">Kg</option>
                          <option value="meter">Meter</option>
                          <option value="roll">Roll</option>
                          <option value="ls">LS</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Cost/Unit" className="mb-3">
                        <Form.Control
                          disabled={view === true}
                          className="input"
                          name="cost_per_unit"
                          value={inputField.cost_per_unit}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value >= 0) {
                              handleInputChange(index, e, 'cost_per_unit');
                            }
                          }}
                          type="text"
                          placeholder="Cost/Unit"
                          required
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="GST" className="mb-3">
                        <Form.Select
                          disabled={view === true}
                          className="input"
                          value={inputField?.gst}
                          name="gst"
                          onChange={(e) => handleInputChange(index, e, 'gst')}
                          required
                        >
                          <option value="">Select GST</option>
                          <option value="0">0%</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                    <Col xs={4}>
                      <FloatingLabel controlId="floatingInput" label="Asset Number" className="mb-3">
                        <Form.Control
                          disabled
                          className="input"
                          name="asset_number"
                          value={inputField.asset_number}
                          onChange={(e) => handleInputChange(index, e, 'asset_number')}
                          type="text"
                          placeholder="Asset Number"
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={3}>
                      <FloatingLabel controlId="floatingInput" label="Total">
                        <Form.Control disabled className="input" name="total" value={inputField.total} type="number" placeholder="Total" />
                      </FloatingLabel>
                    </Col>
                    {view === true ? (
                      ''
                    ) : (
                      <Col xs={1} className="text-end mt-3">
                        {inputFields.length > 1 && (
                          <MdDelete
                            onClick={() => handleRemoveInput(index)}
                            className="text-danger"
                            style={{ cursor: 'pointer', fontSize: '27px' }}
                          />
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
                <hr />
              </>
            ))}
            <Row style={{ alignItems: 'center' }}>
              <Col xs={6}>
                {view === true ? (
                  ''
                ) : (
                  <Button type="button" ref={clickAssetBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                    Add Asset Info
                  </Button>
                )}
              </Col>
              <Col xs={6} className="text-end text-danger">
                <h6>Sub Total: {subTotal}</h6>
              </Col>
            </Row>
            {view === true ? (
              ''
            ) : (
              <Col>
                <Button type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                  {'id' in disposalForm ? 'Update' : 'Add'}
                </Button>
              </Col>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={uploadModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control onChange={handleFileChange} name="invoice" type="file" />
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button
              onClick={() => {
                setIdToUpdated('');
                setUploadModel(false);
              }}
              className="btn app-btn-default btn-sm"
            >
              Cancel
            </button>
            <button onClick={(e) => handleUpload(e, idToUpdated)} className="btn app-btn-primary btn-sm">
              Upload
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Disposal;
